import React, { useState } from 'react';
import Input from '../Input';
import Button from '../Button';
import Form from '../Form';
import Flexor from '../Flexor';
import HeadingText from '../HeadingText';

function ChangePassword({ changePassword }) {
  const [oldPassword, setOldPassword] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordConfirm, setPasswordConfirm] = useState(null);
  return (
    <Form
      style={{
        width: 335,
        margin: 'auto',
        marginTop: 20,
        marginBottom: 20,
      }}>
      <HeadingText text="Change your password" />
      <Flexor flex="0 1 27px" />
      <Input
        required
        value={oldPassword}
        update={setOldPassword}
        label="Old Password"
        type="password"
      />
      <Flexor flex="0 1 20px" />
      <Input
        required
        type="password"
        value={password}
        update={setPassword}
        label="New Password"
      />
      <Flexor flex="0 1 20px" />
      <Input
        required
        type="password"
        value={passwordConfirm}
        update={setPasswordConfirm}
        label="Confirm New Password"
      />
      <Flexor flex="0 1 30px" />
      <Button
        submit
        onClick={() => {
          if (passwordConfirm === password) {
            changePassword(oldPassword, password, passwordConfirm);
          } else {
            alert('Your new password does not match the confirm field.');
          }
        }}
        label="Change Password"
      />
    </Form>
  );
}

export default ChangePassword;
